
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2202',
  depVersions: {
  "customer-portal-app": "static-1.2202",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.465",
  "data-fetching-client": "static-1.9641",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25281",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5563",
  "hs-test-utils": "static-1.7983",
  "hub-http": "static-1.6191",
  "hub-http-shared-msw-handlers": "static-1.9885",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18154",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11434",
  "I18n": "static-7.1615",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6436",
  "payment-link-components": "static-1.23446",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6983",
  "quartz-core": "static-1.6202",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10179",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5317",
  "rich-text-lib": "static-1.19774",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17938",
  "ui-components-test-utils": "static-1.5572",
  "UIComponents": "static-3.8381",
  "foundations-assets": "static-1.4831",
  "foundations-components": "static-1.7867",
  "foundations-theming": "static-1.4386",
  "foundations-theming-specialty": "static-1.2102",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.847",
  "quartz-config": "static-1.761",
  "quartz-routing": "static-1.413",
  "quick-fetch": "static-1.3889",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16638",
  "rpc-client-utils": "static-1.4620",
  "sanitize-text": "static-1.8111",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4737",
  "ui-addon-react-router-dom": "static-1.9513",
  "usage-tracker": "static-1.7314",
  "usage-tracker-anonymous": "static-1.5731",
  "usage-tracker-core": "static-1.7164",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3376",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3260",
  "quartz-webpack": "static-1.3207",
  "bend-plugin-quartz-routing": "static-1.61",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7631",
  "frontend-preferences-client": "static-1.7898",
  "laboratory-lib": "static-3.7128",
  "onboarding-scopes": "static-1.6431",
  "ui-addon-opt": "static-4.8339",
  "HeadJS": "static-2.745",
  "hs-test-utils-bend-plugin": "static-1.3094",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.58",
  "ts-schema": "static-1.4051",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7701",
  "cssUtils": "static-1.782",
  "customer-data-ui-utilities": "static-1.9795",
  "HubStyle": "static-2.11742",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.658",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9856",
  "ui-addon-i18n": "static-1.11119",
  "ui-business-units-lib": "static-1.9018",
  "ui-shepherd-react": "static-3.10123",
  "video-components-external": "static-1.11167",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4295",
  "commerce-tours-lib": "static-1.6032",
  "customer-data-properties": "static-1.51432",
  "getting-started-shared-tasks": "static-1.18414",
  "growth-onboarding-reliability": "static-1.5052",
  "onboarding-tours": "static-1.16536",
  "reference-resolvers-lite": "static-1.8064",
  "sales-checkout-service-client": "static-1.3608",
  "ui-addon-iframeable": "static-1.9026",
  "user-context": "static-1.5071",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4625",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.519",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.658",
  "quartz-head": "static-1.648",
  "quartz-test": "static-1.658",
  "quartz-tracking": "static-1.362",
  "ui-fonts": "static-1.696",
  "usage-tracker-container": "static-1.7304",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9398",
  "data-token-picker": "static-1.16348",
  "FileManagerLib": "static-1.39167",
  "property-translator": "static-1.5370",
  "atom": "static-1.5040",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5824",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5350",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-components": "static-1.4136",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "trellis-assets": "static-1.1767",
  "bend-plugin-foundations-theming": "static-1.2869",
  "foundations-theming-base": "static-1.3371",
  "stylex": "static-1.32",
  "interframe": "static-3.4729",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5728",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.30",
  "chirp-fetch": "static-1.1856",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4444",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3160",
  "inbound-db-properties-service-client": "static-1.3816",
  "superstore": "static-1.4735",
  "feedback-loader": "static-1.29237",
  "ai-components-ui-library": "static-1.8857",
  "ui-addon-video-player": "static-1.8669",
  "ui-coaching-tips": "static-1.28460",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4589",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2467",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8138",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4618",
  "content-media-composition-data-lib": "static-1.12152",
  "content-media-compositions": "static-2.16159",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4123",
  "magpie-lib": "static-1.5536",
  "magpie-types": "static-1.4996",
  "media-bridge-lib": "static-1.18870",
  "video-data-lib": "static-1.34825",
  "commerce-products-lib": "static-1.9431",
  "crm-message-bus": "static-1.42905",
  "growth-data-modal": "static-1.5377",
  "hubspot-apollo-client": "static-1.4846",
  "onboarding-tours-client": "static-1.4750",
  "calling-global-api": "static-1.64406",
  "calling-internal-common": "static-1.31272",
  "calling-lifecycle-internal": "static-1.65788",
  "calling-lifecycle-messages": "static-1.58082",
  "conditional-properties-service-client": "static-1.3770",
  "crm-links": "static-1.6254",
  "customer-data-objects-ui-components": "static-1.12994",
  "customer-data-properties-shared-msw-handlers": "static-1.9212",
  "customer-data-property-utils": "static-1.8054",
  "external-options-client-types": "static-1.4131",
  "file-manager-components": "static-1.23527",
  "framework-data-schema-resolvers": "static-1.6850",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.121",
  "inbound-db-meta-service-client": "static-1.3563",
  "inbounddb-objects-service-types": "static-1.4196",
  "meetings-icalendar-utils-lib": "static-1.601",
  "multi-currency-client-types": "static-1.3664",
  "object-builder-ui-client": "static-1.48629",
  "pipeline-validation-client-types": "static-1.3938",
  "property-value-citations": "static-1.2046",
  "pulse": "static-1.534",
  "smart-property-lib": "static-1.6757",
  "tiered-pricing": "static-1.1132",
  "ui-addon-form-validation": "static-1.10959",
  "growth-onboarding-confetti": "static-1.3036",
  "growth-onboarding-next-action-utils": "static-1.1830",
  "navigation-components": "static-1.17932",
  "onboarding-tours-utils": "static-1.602",
  "ui-shepherd-tracker": "static-1.7504",
  "ui-universal-auth": "static-1.8938",
  "batch-promise": "static-1.1511",
  "navigation-messaging": "static-1.7259",
  "getting-started-shared-tasks-store": "static-1.17532",
  "hubspotter-http-shared-msw-handlers": "static-1.9883",
  "usage-tracker-session-replay": "static-1.5000",
  "audio-components": "static-1.5866",
  "FileManagerCore": "static-1.39026",
  "FileManagerImages": "static-1.36678",
  "video-components": "static-1.13170",
  "foundations-components-legacy": "static-1.892",
  "purchase-motions-api": "static-1.5827",
  "self-service-api": "static-1.10214",
  "signup-constants": "static-1.18784",
  "signup-ui-url-generator": "static-2.8009",
  "trials-service-types": "static-1.3872",
  "usage-tracker-public": "static-1.7125",
  "chatspot-core": "static-1.21139",
  "ContentUtils": "static-1.68267",
  "copilot-toolkit": "static-1.11051",
  "growth-onboarding-feedback-components": "static-1.6551",
  "reactive-lib": "static-1.691",
  "simple-logging-lib": "static-1.3018",
  "commerce-permissions": "static-1.735",
  "customer-data-tracking": "static-1.6854",
  "products-iframe-lib": "static-1.7843",
  "products-ui-components-shared-msw-handlers": "static-1.10267",
  "onboarding-data-sync-lib": "static-1.1906",
  "hubspot-apollo-cache": "static-1.305",
  "calling-error-reporting": "static-1.31278",
  "shared-worker-versioning": "static-1.11007",
  "calling-usage-tracker": "static-1.6512",
  "voice-sms-access-library": "static-1.853",
  "conversations-skeleton-state": "static-1.7217",
  "location-customization-utils-lib": "static-1.9156",
  "crm-pipelines-api-client-types": "static-1.4115",
  "framework-builder-read-service-client": "static-1.3982",
  "framework-data-schema-quick-fetch": "static-1.6755",
  "persist-promise": "static-1.3668",
  "bend-plugin-pulse": "static-1.37",
  "directed-graph": "static-1.904",
  "event-emitter": "static-1.917",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.142",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9968",
  "fsm": "static-1.3701",
  "policy-lib": "static-1.6745",
  "react-tinymce": "static-1.55148",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10031",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54274",
  "tinymce-plugins": "static-1.57388",
  "tinymce-themes": "static-1.56244",
  "growth-onboarding-next-action-components": "static-1.1858",
  "user-context-client": "static-1.4581",
  "nest": "static-1.195",
  "unified-auth-core-lib": "static-1.733",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4502",
  "video-embed": "static-1.35659",
  "content-icons-ui": "static-1.2216",
  "social-insights-client-types": "static-1.22006",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4781",
  "integrations-lib": "static-1.16014",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4233",
  "InboxConnectUtils": "static-4.14724",
  "calling-orchestration-schema": "static-1.35630",
  "crm-record-cards-service-types": "static-1.3581",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4485",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3008",
  "tinymce-data": "static-1.40359",
  "ui-addon-sales-email": "static-1.5179",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12381",
  "layout-dnd-utils": "static-1.11356",
  "react-codemirror": "static-1.10594",
  "ui-brand-identity-lib": "static-1.15130",
  "NamespacedHubStyle": "static-2.9035",
  "outpost": "static-1.4155",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13429",
  "integrations-tracking-lib": "static-1.5568",
  "native-integrations-shared-strings": "static-1.7751",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10339",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.452",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68342",
  "layout-data-lib": "static-1.9681",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2982",
  "google-sheets-integration-lib": "static-1.142",
  "microsoft-drive-integration-lib": "static-1.259",
  "advanced-menus-core": "static-1.15079",
  "advanced-menus-lib": "static-1.12026",
  "ExportDialog": "static-6.10362",
  "ui-memberships-settings-lib": "static-1.33958",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15078",
  "simple-menus-lib": "static-1.16595"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2202",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.465",
  "data-fetching-client": "/data-fetching-client/static-1.9641",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25281",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5563",
  "hs-test-utils": "/hs-test-utils/static-1.7983",
  "hub-http": "/hub-http/static-1.6191",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9885",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18154",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11434",
  "I18n": "/I18n/static-7.1615",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6436",
  "payment-link-components": "/payment-link-components/static-1.23446",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6983",
  "quartz-core": "/quartz-core/static-1.6202",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10179",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5317",
  "rich-text-lib": "/rich-text-lib/static-1.19774",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17938",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5572",
  "UIComponents": "/UIComponents/static-3.8381",
  "foundations-assets": "/foundations-assets/static-1.4831",
  "foundations-components": "/foundations-components/static-1.7867",
  "foundations-theming": "/foundations-theming/static-1.4386",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2102",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.847",
  "quartz-config": "/quartz-config/static-1.761",
  "quartz-routing": "/quartz-routing/static-1.413",
  "quick-fetch": "/quick-fetch/static-1.3889",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16638",
  "rpc-client-utils": "/rpc-client-utils/static-1.4620",
  "sanitize-text": "/sanitize-text/static-1.8111",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4737",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9513",
  "usage-tracker": "/usage-tracker/static-1.7314",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5731",
  "usage-tracker-core": "/usage-tracker-core/static-1.7164",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3376",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3260",
  "quartz-webpack": "/quartz-webpack/static-1.3207",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.61",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7631",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7898",
  "laboratory-lib": "/laboratory-lib/static-3.7128",
  "onboarding-scopes": "/onboarding-scopes/static-1.6431",
  "ui-addon-opt": "/ui-addon-opt/static-4.8339",
  "HeadJS": "/HeadJS/static-2.745",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3094",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.58",
  "ts-schema": "/ts-schema/static-1.4051",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7701",
  "cssUtils": "/cssUtils/static-1.782",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9795",
  "HubStyle": "/HubStyle/static-2.11742",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.658",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9856",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11119",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9018",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10123",
  "video-components-external": "/video-components-external/static-1.11167",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4295",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6032",
  "customer-data-properties": "/customer-data-properties/static-1.51432",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18414",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5052",
  "onboarding-tours": "/onboarding-tours/static-1.16536",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8064",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3608",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9026",
  "user-context": "/user-context/static-1.5071",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4625",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.519",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.658",
  "quartz-head": "/quartz-head/static-1.648",
  "quartz-test": "/quartz-test/static-1.658",
  "quartz-tracking": "/quartz-tracking/static-1.362",
  "ui-fonts": "/ui-fonts/static-1.696",
  "usage-tracker-container": "/usage-tracker-container/static-1.7304",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9398",
  "data-token-picker": "/data-token-picker/static-1.16348",
  "FileManagerLib": "/FileManagerLib/static-1.39167",
  "property-translator": "/property-translator/static-1.5370",
  "atom": "/atom/static-1.5040",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5824",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5350",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4136",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "trellis-assets": "/trellis-assets/static-1.1767",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2869",
  "foundations-theming-base": "/foundations-theming-base/static-1.3371",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4729",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5728",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.30",
  "chirp-fetch": "/chirp-fetch/static-1.1856",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4444",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3816",
  "superstore": "/superstore/static-1.4735",
  "feedback-loader": "/feedback-loader/static-1.29237",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8857",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8669",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28460",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4589",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2467",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8138",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4618",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12152",
  "content-media-compositions": "/content-media-compositions/static-2.16159",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4123",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "magpie-types": "/magpie-types/static-1.4996",
  "media-bridge-lib": "/media-bridge-lib/static-1.18870",
  "video-data-lib": "/video-data-lib/static-1.34825",
  "commerce-products-lib": "/commerce-products-lib/static-1.9431",
  "crm-message-bus": "/crm-message-bus/static-1.42905",
  "growth-data-modal": "/growth-data-modal/static-1.5377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4846",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4750",
  "calling-global-api": "/calling-global-api/static-1.64406",
  "calling-internal-common": "/calling-internal-common/static-1.31272",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65788",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58082",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3770",
  "crm-links": "/crm-links/static-1.6254",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12994",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9212",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8054",
  "external-options-client-types": "/external-options-client-types/static-1.4131",
  "file-manager-components": "/file-manager-components/static-1.23527",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6850",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.121",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3563",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4196",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.601",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3664",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48629",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3938",
  "property-value-citations": "/property-value-citations/static-1.2046",
  "pulse": "/pulse/static-1.534",
  "smart-property-lib": "/smart-property-lib/static-1.6757",
  "tiered-pricing": "/tiered-pricing/static-1.1132",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10959",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3036",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1830",
  "navigation-components": "/navigation-components/static-1.17932",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.602",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7504",
  "ui-universal-auth": "/ui-universal-auth/static-1.8938",
  "batch-promise": "/batch-promise/static-1.1511",
  "navigation-messaging": "/navigation-messaging/static-1.7259",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17532",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9883",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5000",
  "audio-components": "/audio-components/static-1.5866",
  "FileManagerCore": "/FileManagerCore/static-1.39026",
  "FileManagerImages": "/FileManagerImages/static-1.36678",
  "video-components": "/video-components/static-1.13170",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.892",
  "purchase-motions-api": "/purchase-motions-api/static-1.5827",
  "self-service-api": "/self-service-api/static-1.10214",
  "signup-constants": "/signup-constants/static-1.18784",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8009",
  "trials-service-types": "/trials-service-types/static-1.3872",
  "usage-tracker-public": "/usage-tracker-public/static-1.7125",
  "chatspot-core": "/chatspot-core/static-1.21139",
  "ContentUtils": "/ContentUtils/static-1.68267",
  "copilot-toolkit": "/copilot-toolkit/static-1.11051",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6551",
  "reactive-lib": "/reactive-lib/static-1.691",
  "simple-logging-lib": "/simple-logging-lib/static-1.3018",
  "commerce-permissions": "/commerce-permissions/static-1.735",
  "customer-data-tracking": "/customer-data-tracking/static-1.6854",
  "products-iframe-lib": "/products-iframe-lib/static-1.7843",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10267",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1906",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.305",
  "calling-error-reporting": "/calling-error-reporting/static-1.31278",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11007",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6512",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.853",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7217",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9156",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4115",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3982",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6755",
  "persist-promise": "/persist-promise/static-1.3668",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.37",
  "directed-graph": "/directed-graph/static-1.904",
  "event-emitter": "/event-emitter/static-1.917",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.142",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9968",
  "fsm": "/fsm/static-1.3701",
  "policy-lib": "/policy-lib/static-1.6745",
  "react-tinymce": "/react-tinymce/static-1.55148",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10031",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54274",
  "tinymce-plugins": "/tinymce-plugins/static-1.57388",
  "tinymce-themes": "/tinymce-themes/static-1.56244",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1858",
  "user-context-client": "/user-context-client/static-1.4581",
  "nest": "/nest/static-1.195",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.733",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4502",
  "video-embed": "/video-embed/static-1.35659",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4781",
  "integrations-lib": "/integrations-lib/static-1.16014",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4233",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14724",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35630",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3581",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4485",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3008",
  "tinymce-data": "/tinymce-data/static-1.40359",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5179",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12381",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11356",
  "react-codemirror": "/react-codemirror/static-1.10594",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15130",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9035",
  "outpost": "/outpost/static-1.4155",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13429",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5568",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7751",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10339",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.452",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68342",
  "layout-data-lib": "/layout-data-lib/static-1.9681",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2982",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.142",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.259",
  "advanced-menus-core": "/advanced-menus-core/static-1.15079",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12026",
  "ExportDialog": "/ExportDialog/static-6.10362",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33958",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15078",
  "simple-menus-lib": "/simple-menus-lib/static-1.16595"
}
};
